var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageLayoutWrapper',{attrs:{"page":"search"}},[(_vm.enableGlobalSearch)?_c('GlobalSearch'):_c('GlobalSearchLegacy')],1)}
var staticRenderFns = []

export { render, staticRenderFns }